"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaxInfoDetSelectorCNED = exports.MaxInfoDetSelector = exports.Selector = void 0;
const irt_1 = require("./irt");
const utils_1 = require("./utils");
class Selector {
    /** Abstract class used to select the next item to ask
     *
     * @param itemsIds : list of all items of the test bank
     * @param administeredItems : list of the items that have already been asked in the test
     * @returns the items that haven't been administered yet
     */
    getNonAdministered(itemsIds, administeredItems) {
        var nonAdministeredItems = [];
        for (let ID of itemsIds) {
            if (!(administeredItems.includes(ID))) {
                nonAdministeredItems.push(ID);
            }
        }
        return nonAdministeredItems;
    }
    /**
     * sorts the items by decreasing value of the determinant of the Fisher Matrix
     * that would be obtained if an item was asked.
     * @param discriminations : discriminations (vector) of the items of the bank
     * @param difficulties : difficulties (scalar) of the items of the bank
     * @param thetaEstimation : current estimation of the theta parameter (before a new item is asked)
     * @param currentFisherMat : current Fisher Information Matrix for the test (before a new item is asked)
     * @returns the items sorted by decreasing value of the determinant of the new Fisher Matrix that would
     * obtained by adding the current test Fisher Matrix and the Fisher Matrix of the particular item.
     */
    sortByInfoDet(discriminations, difficulties, thetaEstimation, currentFisherMat) {
        const allFisherdet = (0, irt_1.allFisherDet)(thetaEstimation, discriminations, difficulties, currentFisherMat);
        return allFisherdet;
    }
    sortByInfoDetCNED(discriminations, difficulties, thetaEstimation, currentFisherMat) {
        const allFisherdet = (0, irt_1.allFisherDet)(thetaEstimation, discriminations, difficulties, currentFisherMat);
        const orderedFisherDet = (0, utils_1.argsortDesc)(Object.values(allFisherdet));
        return orderedFisherDet;
    }
}
exports.Selector = Selector;
class MaxInfoDetSelector extends Selector {
    /**
     * Class which handles selection of the next item to ask depending on the determinant of FIsher Matrix
     * @param dim
     */
    constructor(dim) {
        super();
    }
    /**
     * Selects the next item to ask by maximizing the determinant of the Fisher Information Matrix
     * @param discriminations : discriminations of all items in the bank
     * @param difficulties : difficulties of all items in the bank
     * @param administeredItems : list of items already asked
     * @param thetaEstimation : current estimation of the student's level
     * @param InformationMatrix : current Fisher Information Matrix of the test
     * @returns list of item in decreasing order of information
     */
    select(discriminations, difficulties, thetaEstimation, InformationMatrix, discriminations_no_anc) {
        // Calcule deux matrices de fisher
        // une pour prendre en compte les prérequis (cas si rep = 1) et l'autre sans (cas rep = 0)
        const allFisherdet = this.sortByInfoDet(discriminations, difficulties, thetaEstimation, InformationMatrix);
        const allFisherdet_no_anc = this.sortByInfoDet(discriminations_no_anc, difficulties, thetaEstimation, InformationMatrix);
        // on fait une moyenne des deux matrices pour 
        const allFisherdet_final = {};
        for (let i of Object.keys(allFisherdet)) {
            allFisherdet_final[i] = ((allFisherdet[i] + allFisherdet_no_anc[i]));
        }
        return allFisherdet_final;
    }
}
exports.MaxInfoDetSelector = MaxInfoDetSelector;
class MaxInfoDetSelectorCNED extends Selector {
    /**
     * Class which handles selection of the next item to ask depending on the determinant of FIsher Matrix
     * @param dim
     */
    constructor(dim) {
        super();
    }
    /**
     * Selects the next item to ask by maximizing the determinant of the Fisher Information Matrix
     * @param discriminations : discriminations of all items in the bank
     * @param difficulties : difficulties of all items in the bank
     * @param administeredItems : list of items already asked
     * @param thetaEstimation : current estimation of the student's level
     * @param InformationMatrix : current Fisher Information Matrix of the test
     * @returns identifier of the next item to ask
     */
    select(discriminations, difficulties, thetaEstimation, administeredItems, InformationMatrix) {
        var orderedItems = [];
        const orderedIndices = this.sortByInfoDetCNED(discriminations, difficulties, thetaEstimation, InformationMatrix);
        const nonOrderedKeys = Object.keys(difficulties);
        for (let i = 0; i < orderedIndices.length; i++) {
            orderedItems.push(nonOrderedKeys[orderedIndices[i]]);
        }
        var validIndices = this.getNonAdministered(orderedItems, administeredItems);
        if (validIndices.length == 0) {
            console.warn("There are no more items to be applied");
            return null;
        }
        var selectedItem = validIndices[0];
        return selectedItem;
    }
}
exports.MaxInfoDetSelectorCNED = MaxInfoDetSelectorCNED;
